import { useTranslation } from 'react-i18next';

const TILES = [
  { label: 'Post', key: 'post', color: 'text-[#334155]', bg: 'bg-[#F8FAFC] border-[#E2E8F0]' },
  { label: 'Shoutout', key: 'shoutout', color: 'text-[#7C3AED]', bg: 'bg-[#F5F3FF] border-[#DDD6FE]' },
  { label: 'Comment', key: 'comment', color: 'text-[#CA8A04]', bg: 'bg-[#FEFCE8] border-[#FEF08A]' },
  { label: 'User', key: 'user', color: 'text-[#1D4ED8]', bg: 'bg-[#EFF6FF] border-[#BFDBFE]' },
  { label: 'Story', key: 'story', color: 'text-[#16A34A]', bg: 'bg-[#F0FDF4] border-[#BBF7D0]' },
  { label: 'FanCam', key: 'fancam', color: 'text-[#E11D48]', bg: 'bg-[#FFF1F2] border-[#FECDD3]' },
  { label: 'FanChat', key: 'fanchat', color: 'text-[#0D9488]', bg: 'bg-[#F0FDFA] border-[#99F6E4]' },
  { labelKey: 'admin.reports.entityTypes.fanchatTopic', key: 'fanchatTopic', color: 'text-[#0E7490]', bg: 'bg-[#ECFEFF] border-[#A5F3FC]' },
  { labelKey: 'admin.reports.entityTypes.fanchatMessage', key: 'fanchatMessage', color: 'text-[#0369A1]', bg: 'bg-[#F0F9FF] border-[#BAE6FD]' },
];

const ReportsSummaryBar = ({ summary }) => {
  const { t } = useTranslation();

  if (!summary) return null;

  return (
    <div className="px-6 mb-4">
      <p className="text-sm font-semibold text-[#334155] mt-4 mb-2">Pending Reports</p>
    <div className="grid grid-cols-3 sm:grid-cols-9 gap-3">
      {TILES.map((tile) => (
        <div key={tile.key} className={`rounded-xl border px-3 py-3 ${tile.bg}`}>
          <p className="text-[10px] font-semibold text-[#7989A0] uppercase tracking-wide mb-1 truncate">
            {tile.labelKey ? t(tile.labelKey) : tile.label}
          </p>
          <p className={`text-[20px] font-bold leading-none ${tile.color}`}>
            {summary[tile.key] ?? 0}
          </p>
        </div>
      ))}
    </div>
    </div>
  );
};

export default ReportsSummaryBar;
